export type DomMutation = (_document: Document, _range: Range | null) => void;

export const restoreRange = (document: Document, range: Range | null): boolean => {
    const selection = document.getSelection();
    if (!selection || !range) return false;

    try {
        selection.removeAllRanges();
        selection.addRange(range);
        return true;
    } catch {
        return false;
    }
};

export const applyDomMutation = (document: Document, range: Range | null, mutate: DomMutation): void => {
    restoreRange(document, range);
    mutate(document, range);
};
